import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { Options } from 'highcharts';
import Highcharts from 'highcharts';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import { CILDashboardService } from 'src/app/services/cil-dashboard-service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { DtServiceService } from 'src/app/services/dtService.service';
import { DefectDashBoardService } from 'src/app/services/defect-dashboard-service';
import { differenceInCalendarDays } from 'date-fns';
import { BtnCellRendererDefectDashBoard } from 'src/app/btn-cell-rendererDefectDashBoard.component';
import { DefectActionService } from 'src/app/services/defect-action.service';
import { DefectConfigurationService } from 'src/app/services/defect-configuration.service';
import { MatCheckboxRendererComponent } from 'src/app/mat-checkbox-renderer';
import { CustomTooltip } from 'src/app/custom-tooltip.component';
import { BtnCellRenderer } from 'src/app/btn-cell-renderer.component';
import { BtnCellRendererDefect } from 'src/app/btn-cell-rendererDefect.component';
import { BtnCellRendererActualEntry } from 'src/app/btn-cell-rendererActualEntry.component';
import { PrimeCellEditorComponent } from 'src/app/editors/prime-cell-editor.component';
import { CustomDateComponent } from 'src/app/date-components/custom-date-component.component';
import * as XLSX from 'xlsx-js-style';
import * as _ from 'lodash';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Component({
  selector: 'app-new-defect-dashboard',
  templateUrl: './new-defect-dashboard.component.html',
  styleUrls: ['./new-defect-dashboard.component.scss'],
})
export class NewDefectDashboardComponent implements OnInit {
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('CloseDefect') private CloseDefect!: TemplateRef<any>;
  @ViewChild('ViewActionDetailModel') private ViewActionDetailModel!: TemplateRef<any>;
  @ViewChild('imageViewModal') private imageViewModal!: TemplateRef<any>;
  displayedColumns = ['name', 'assignto', 'date', 'newDate', 'closedate', 'comments'];
  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  filteredComponents: any;
  breadcrumList: any;
  moduleId!: any;
  pageId!: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any;
  unitList!: any;
  componentList!: any;
  permisson!: any;
  CLLDashboardForm!: FormGroup;
  TotalDefects!: any;
  TotalDefecteSolved!: any;
  CILAdherence!: any;
  TotalDefectsPerc!: any;
  CILTask!: any;

  dashboardData: any;
  rowData!: any[];
  chartDS!: Chart;
  chartDP!: Chart;
  chartDC!: Chart;
  chartDT!: Chart;

  chartUnit!: Chart;
  chartDept!: Chart;
  chartLine!: Chart;
  chartCILTool!: Chart;
  options!: Options;
  image!: any;
  currentImagePath!: any;
  defaultExcelExportParams: any;
  frameworkComponents: any;

  languageDir = 'ltr';

  /** i18n section for this page in the assets/i18n/*.json files */
  private readonly PAGE = 'NewDefectDashboard';

  /** true once the empty-state text has been pushed into the libraries */
  private emptyStateApplied = false;
  langObj: any = {};

  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  dashboarUnitData: any[];
  dashboardLineData: any[];
  dashboardDeptData: any[];
  linepercentageGraphData: any = [];
  DeptpercentageGraphData: any = [];
  chartLinePercentage: Chart;
  chartDeptPercentage: Chart;
  unitpercentageGraphData: any = [];
  chartUnitPercentage: Chart;
  deparmentFiltList: any;
  deparmentList: any;
  gridApi: any;
  gridApiDefect: any;
  gridColumnApi: any;
  paginationPageSize: 5;
  flag = true;
  gridOptions: any = {
    defaultColDef: {
      filter: true,
      headerHeight: 50,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),

    frameworkComponents: {
      checkboxRenderer: MatCheckboxRendererComponent,
      agDateInput: CustomDateComponent,
      primeCellEditor: PrimeCellEditorComponent,
      btnCellRendererActualEntry: BtnCellRendererActualEntry,
      btnCellRenderDefect: BtnCellRendererDefect,
      btnCellRenderer: BtnCellRenderer,
      customTooltip: CustomTooltip,


    },
  };
  gridOptionsDefectAction: any = {
    defaultColDef: {
      filter: 'agTextColumnFilter',
      headerHeight: 50,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),

    frameworkComponents: {
      checkboxRenderer: MatCheckboxRendererComponent,
      agDateInput: CustomDateComponent,
      primeCellEditor: PrimeCellEditorComponent,
      btnCellRendererActualEntry: BtnCellRendererActualEntry,
      btnCellRenderDefect: BtnCellRendererDefect,
      btnCellRenderer: BtnCellRenderer,
      customTooltip: CustomTooltip,


    },
  };
  todayDate = new Date();
  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.todayDate) > 0;
  // columnDefs: ({ headerName: string; field: string; filter: string; valueFormatter?: undefined; cellRenderer?: undefined; cellRendererParams?: undefined; maxWidth?: undefined; suppressMenu?: undefined; } | { headerName: string; field: string; filter: string; valueFormatter: (params: any) => string; cellRenderer?: undefined; cellRendererParams?: undefined; maxWidth?: undefined; suppressMenu?: undefined; } | { headerName: string; field: string; cellRenderer: (params: any) => string; filter?: undefined; valueFormatter?: undefined; cellRendererParams?: undefined; maxWidth?: undefined; suppressMenu?: undefined; } | { headerName: string; cellRenderer: string; cellRendererParams: { onClick: any; label: string; }; maxWidth: number; suppressMenu: boolean; field?: undefined; filter?: undefined; valueFormatter?: undefined; })[];
  columnDefs: any
  actionDataSource: any;
  totalCount: any;
  openCount: any;
  inProgressCount: any;
  delayCount: any;
  closedCount: any;
  completedCount: any;
  key: { groupId: any; plantId: any; lineId: number; UnitId: number; ComponentId: number; UserId: number; dtStartDate: Date; dtEndDate: Date; Status: string; };
  IsMachine = false;
  ButtonType: any;
  CloseDefectForm!: FormGroup
  CloseImage: any;
  columnDefsActionView: any;
  rowDataViewActions!: any;
  ImageUrl: string = "";
  slidesImages: any[] = [];
  gridColumnApiDefect: any;
  plantSession: any;
  userSession: any;
  groupSession: any;
  isAccess = ApplicationPermission.Defect_Dashboard_ACCESS;
  isCreate = ApplicationPermission.Defect_Dashboard_CREATE;
  isUpdate = ApplicationPermission.Defect_Dashboard_UPDATE;
  isDelete = ApplicationPermission.Defect_Dashboard_DELETE;
  constructor(
    private baseApi: BaseApi,
    private formBuilder: FormBuilder,
    private productivityservice: ProductivityService,
    private cilService: CILDashboardService,
    private toaster: ToastrService,
    public router: Router,
    private userService: UserManagementService,
    private enterpriseGroupService: EnterPriseGroupService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public translater: TranslaterService,
    public translate: TranslateService,
    private dtService: DtServiceService,
    private defectService: DefectDashBoardService,
    private defectService2: DefectConfigurationService,
    private defectActionService: DefectActionService,
  ) {
    this.frameworkComponents = {
      buttonRenderer: ButtonViewRendererComponent,
      BtnCellRendererDefectDashBoard: BtnCellRendererDefectDashBoard
    };
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.languageDir = event.lang === 'ar' ? 'rtl' : 'ltr';
      // The database tags are only an override. Repaint from the i18n files
      // straight away so the switch never depends on that request succeeding.
      this.langObj = {};
      this.applyLanguageToView();
      this.getLangWords();
    });
    this.columnDefs = [
      {
        field: 'Action', headerName: 'Action', cellRenderer: 'BtnCellRendererDefectDashBoard',
        cellRendererParams: {
          clicked: function (field: any) { },
          // lets the renderer resolve its tooltips for this page, and pick up
          // database translations the same way the rest of the page does
          page: 'NewDefectDashboard',
          getLangObj: () => this.langObj,
        },
        // the getter used to sit inside cellRendererParams, where ag-Grid
        // never looks for it, so this header stayed English
        headerValueGetter: this.localizeHeader.bind(this),
        // sortable: true,
        filter: true,
        resizable: true,
        // wrapText: true,
        maxWidth: 100

      },
      {
        headerName: 'Defect Entry', field: 'DefectEntry', filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Priority', field: 'Priority', filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Status', field: 'Status', filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Line', field: 'PL_Desc', filter: true, hide: this.IsMachine,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Machine', field: 'PU_Desc', filter: true, hide: this.IsMachine,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Component', field: 'ComponentName', filter: true, hide: this.IsMachine,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Department', field: 'DepartmentName', filter: true, hide: !this.IsMachine,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Defect Type', field: 'DefectType', filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      // { headerName: 'Assign To', field: 'AssignTo', filter:true },
      // { headerName: 'Target Date', field: 'TargetDate', filter: true, valueFormatter: function (params: any) {return params.value !== null ? moment(params.value).format('MM/DD/YYYY HH:mm:ss') : '' }},

      // { headerName: 'Comments', field: 'Comments', filter:true },
      // { headerName: 'PostImageName', field: 'PostImageName', cellRenderer: function (params: any) { return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value}" src="${params.value !== '' ? environment.O3ImageUrl + params.value : 'assets/images/no-image.png'}">` } },
      {
        headerName: 'PreImageName', field: 'PreImage',
        cellRenderer: function (params: any) { return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value}" src="${params.value !== '' ? params.value : 'assets/images/no-image.png'}">` },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      // { headerName: 'PreImageName', field: 'PreImage', cellRenderer: (params: any) => {
      //   return `
      //   <div>
      //     <button mat-mini-fab="" color="primary" ptooltip="Send for Approval" title="SendforApproval" tooltipposition="top" class="mat-focus-indicator sortactionApproval mat-mini-fab mat-button-base mat-primary" style="background-color: green;" ng-reflect-color="primary" ng-reflect-text="Action Approval" ng-reflect-tooltip-position="top"><span class="mat-button-wrapper"><i class="fa fa-file" style="color: #fff;"></i></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
      //   </div>
      //   `;
      // },
      // sortable: true,
      // filter: true,
      // resizable: true,
      // wrapText: true ,
      // maxWidth : 100 },
      {
        headerName: 'Created By', field: 'CreatedBy', filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Created On', field: 'CreatedOn', filter: true, valueFormatter: function (params: any) { return moment(params.value).format('DD/MM/YYYY HH:mm:ss') },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Close Date', field: 'CloseDate', filter: true, valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Closed By', field: 'ClosedBy', filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
    ]
    this.columnDefsActionView = [
      {
        headerName: 'Action Name',
        headerValueGetter: (p: any) => this.t('ActionName', 'Action Name'),
        field: 'ActionName',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Responsible',
        headerValueGetter: (p: any) => this.t('Responsible', 'Responsible'),
        field: 'responsibleName',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Observation',
        headerValueGetter: (p: any) => this.t('Observation', 'Observation'),
        field: 'Observation',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
      },
      {
        headerName: 'Remarks',
        headerValueGetter: (p: any) => this.t('Remarks', 'Remarks'),
        field: 'Remarks',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
      },
      {
        headerName: 'TargetDate',
        headerValueGetter: (p: any) => this.t('TargetDate', 'TargetDate'),
        field: 'TargetDate',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' }
      },
      {
        headerName: 'NewTargetDate',
        headerValueGetter: (p: any) => this.t('NewTargetDate', 'NewTargetDate'),
        field: 'NewTargetDate',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' }
      },
      {
        headerName: 'No Of Misses',
        headerValueGetter: (p: any) => this.t('NoOfMisses', 'No Of Misses'),
        field: 'NoOfMisses',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      // {
      //   headerName: 'PictureBefore',
      //   field: 'PictureBefore',
      //   sortable: true,
      //   filter: true,
      //   resizable: true,
      //   wrapText: true,
      //   // headerValueGetter: this.localizeHeader.bind(this)
      // },
      {
        headerName: 'PictureAfter Req',
        headerValueGetter: (p: any) => this.t('PictureAfterRequire', 'PictureAfter Req'),
        field: 'IsRequiredPictureAfter',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'PictureAfter',
        headerName: 'Picture After',
        headerValueGetter: (p: any) => this.t('PictureAfter', 'Picture After'),
        sortable: true,
        resizable: true,
        filter: false,
        cellRenderer: function (params: any) {
          let html = `<img style="width: 50px; height: 40px;" src="assets/images/no-image.png"/>`;
          if (params && params.value) {
            html = '';
            html = `<img style="width: 50px; height: 40px;" src="${params.value}"/>`;

          }
          return html;
        },
      },
      {
        headerName: 'Rejected',
        headerValueGetter: (p: any) => this.t('Rejected', 'Rejected'),
        field: 'IsRejected',
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'IsCompleted',
        headerName: 'Completed',
        headerValueGetter: (p: any) => this.t('Completed', 'Completed'),
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
        // headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'IsVerified',
        headerName: 'Verified',
        headerValueGetter: (p: any) => this.t('Verified', 'Verified'),
        sortable: true,
        filter: true,
        resizable: true,
        width: 200,
        wrapText: true,
        cellRenderer: 'checkboxRenderer',
        cellRendererParams: { disable: true },
        editable: false,
      },
    ];
    this.defaultExcelExportParams = {
      addImageToCell: function (
        rowIndex: number,
        col: any,
        value: any,
        callback: any
      ) {
        if (col.colId === 'PreImage' || col.colId === 'PostImage') {
        } else {
          return;
        }
      },
    };
  }

  ngOnInit(): void {
    // languageDir was only updated by onLangChange, so loading the page with
    // Arabic already selected left it at 'ltr' and the page laid out LTR.
    this.languageDir = this.translate.currentLang === 'ar' ? 'rtl' : 'ltr';
    this.plantSession = this.baseApi?.getPlantFromStorage();
    this.userSession = this.baseApi?.getUserSession();
    this.groupSession = this.baseApi?.getGroupFromStorage();
    this.getLangWords();
    this.initform();
    this.getDepartments();
    this.CLLDashboardForm.controls.unit.patchValue('0');
    this.CLLDashboardForm.controls.components.patchValue('0');
    this.CLLDashboardForm.controls.line.patchValue('0');
    this.CLLDashboardForm.controls.Departments.patchValue('0');
    //this.datasource();
    //this.GetBreadcrumList();
    //this.GetMenuAccess();
    this.CloseDefectForm = this.formBuilder.group({

      remarks: [''],
      image: [''],
    })
    // this.setData();
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    this.moduleId = this.baseApi.getUserPermissionsSession().find(x => x.menuId == this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.columnDefs = [
        {
          field: 'Action', headerName: 'Action', cellRenderer: 'BtnCellRendererDefectDashBoard',
          cellRendererParams: {
            clicked: function (field: any) { },
            // lets the renderer resolve its tooltips for this page, and pick up
            // database translations the same way the rest of the page does
            page: 'NewDefectDashboard',
            getLangObj: () => this.langObj,
          },
          // the getter used to sit inside cellRendererParams, where ag-Grid
          // never looks for it, so this header stayed English
          headerValueGetter: this.localizeHeader.bind(this),
          sortable: true,
          filter: true,
          resizable: true,
          wrapText: true,
          maxWidth: 100
        },
        {
          headerName: 'Defect Entry', field: 'DefectEntry', filter: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Priority', field: 'Priority', filter: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Status', field: 'Status', filter: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Line', field: 'PL_Desc', filter: true, hide: this.IsMachine,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Machine', field: 'PU_Desc', filter: true, hide: this.IsMachine,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Component', field: 'ComponentName', filter: true, hide: this.IsMachine,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Department', field: 'DepartmentName', filter: true, hide: !this.IsMachine,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Defect Type', field: 'DefectType', filter: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        // { headerName: 'Assign To', field: 'AssignTo', filter:true },
        // { headerName: 'Target Date', field: 'TargetDate', filter: true, valueFormatter: function (params: any) {return params.value !== null ? moment(params.value).format('MM/DD/YYYY HH:mm:ss') : '' }},

        // { headerName: 'Comments', field: 'Comments', filter:true },
        // { headerName: 'PostImageName', field: 'PostImageName', cellRenderer: function (params: any) { return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value}" src="${params.value !== '' ? environment.O3ImageUrl + params.value : 'assets/images/no-image.png'}">` } },
        {
          headerName: 'PreImageName', field: 'PreImage',
          cellRenderer: function (params: any) { return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value}" src="${params.value !== '' ? params.value : 'assets/images/no-image.png'}">` },
          headerValueGetter: this.localizeHeader.bind(this)
        },
        // { headerName: 'PreImageName', field: 'PreImage', cellRenderer: (params: any) => {
        //   return `
        //   <div>
        //     <button mat-mini-fab="" color="primary" ptooltip="Send for Approval" title="SendforApproval" tooltipposition="top" class="mat-focus-indicator sortactionApproval mat-mini-fab mat-button-base mat-primary" style="background-color: green;" ng-reflect-color="primary" ng-reflect-text="Action Approval" ng-reflect-tooltip-position="top"><span class="mat-button-wrapper"><i class="fa fa-file" style="color: #fff;"></i></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
        //   </div>
        //   `;
        // },
        // sortable: true,
        // filter: true,
        // resizable: true,
        // wrapText: true ,
        // maxWidth : 100 },
        {
          headerName: 'Created By', field: 'CreatedBy', filter: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Created On', field: 'CreatedOn', filter: true, valueFormatter: function (params: any) { return moment(params.value).format('DD/MM/YYYY HH:mm:ss') },
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Close Date', field: 'CloseDate', filter: true, valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' },
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Closed By', field: 'ClosedBy', filter: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
      ]
    });

  }

  initform() {

    this.CLLDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      Departments: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      components: ['', Validators.required],
      // dateStart: [new Date(), Validators.required],
      // dateEnd: [new Date (), Validators.required],
      datePicker: [[new Date(moment().subtract(1, 'd').toString()), new Date()]],
      shift: ['', []],
    });
  }

  drawDefectType() {
    let dtLabel: any[] = new Array();
    let dtData: any[] = new Array();
    if (this.dashboardData.lstDefectType !== null && this.dashboardData.lstDefectType.length > 0) {
      this.dashboardData.lstDefectType.forEach((element: any) => {
        dtLabel.push(element.Name);
        dtData.push([element.Name, parseFloat(element.Countt)]);
      });
    }
    this.options = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: ''
      },
      xAxis: {
        categories: dtLabel,
      },
      credits: {
        enabled: false
      },
      series: [{
        name: this.t('DefectTypeSeries', 'Defect Type'),
        type: 'column',
        data: dtData
      }]
    };
    let chart = new Chart(this.options);
    this.chartDT = chart;
  }

  drawDefectClassification() {
    let dcLabel: any[] = new Array();
    let dcData: any[] = new Array();
    if (this.dashboardData.lstClassification !== null && this.dashboardData.lstClassification.length > 0) {
      this.dashboardData.lstClassification.forEach((element: any) => {
        dcLabel.push(element.Name);
        dcData.push([element.Name, parseFloat(element.Countt)]);
      });
    }
    this.options = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: ''
      },
      xAxis: {
        categories: dcLabel,
      },
      credits: {
        enabled: false
      },
      series: [{
        name: this.t('CILClassificationSeries', 'CIL Classification'),
        type: 'column',
        data: dcData
      }]
    };
    let chart = new Chart(this.options);
    this.chartDC = chart;
  }

  drawDefectPriority() {
    let dpLabel: any[] = new Array();
    let dpData: any[] = new Array();
    if (this.dashboardData.lstPriority !== null && this.dashboardData.lstPriority.length > 0) {
      this.dashboardData.lstPriority.forEach((element: any) => {
        dpLabel.push(element.Name);
        dpData.push([element.Name, parseFloat(element.Countt)]);
      });
    }
    this.options = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: ''
      },
      xAxis: {
        categories: dpLabel,
      },
      credits: {
        enabled: false
      },
      series: [{
        name: this.t('DefectPrioritySeries', 'Defect Priority'),
        type: 'column',
        data: dpData
      }]
    };
    let chart = new Chart(this.options);
    this.chartDP = chart;
  }

  drawDefectStatus() {
    let dsLabel: any[] = new Array();
    let dsData: any[] = new Array();
    if (this.dashboardData.lstStatus !== null && this.dashboardData.lstStatus.length > 0) {
      this.dashboardData.lstStatus.forEach((element: any) => {
        dsLabel.push(element.Name);
        dsData.push([element.Name, parseFloat(element.Countt)]);
      });
    }
    this.options = {
      chart: {
        type: 'column',
      },
      colors: ['#0f0fd1'],
      title: {
        text: ''
      },
      xAxis: {
        categories: dsLabel,
      },
      credits: {
        enabled: false
      },
      series: [{
        name: this.t('DefectStatusSeries', 'Defect Status'),
        type: 'column',
        data: dsData
      }]
    };
    let chart = new Chart(this.options);
    this.chartDS = chart;
  };
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.autoSizeAllColumns();
  }

  autoSizeGrid() {
    this.gridApi.setRowData(this.rowDataViewActions);
    this.gridColumnApi.autoSizeAllColumns();
  }

  onGridReadyDefect(params: any): void {
    this.gridApiDefect = params.api;
    this.gridColumnApiDefect = params.columnApi;
    this.gridColumnApiDefect.autoSizeAllColumns();
  }

  autoSizeDefect() {
    this.gridApiDefect.setRowData(this.rowData);
    this.gridColumnApiDefect.autoSizeAllColumns();
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    this.ButtonType = params.event.target.classList[2];
    // if (col === 'PostImageName') {
    //   this.image = params.data.PostImageName;
    //   this.openPictureBeforeModal();
    // } if (col === 'PreImageName') {
    //   this.image = params.data.PreImageName;
    //   this.openPictureBeforeModal();
    // }
    if (col === 'Action') {
      this.ButtonType = params.event.target.textContent;
      if (
        this.ButtonType === 'remove_red_eye 2 '
      ) {
        // this.defectId = params.data.id;
        this.CloseDefectForm.reset();

        this.dialog.open(this.CloseDefect, {
          width: '30%',
          height: 'auto',
        });
        this.CloseImage = params.data.CloseImage;
        this.CloseDefectForm.get('remarks').setValue(params.data.ClosedRemarks)
      }
      if (
        this.ButtonType === 'remove_red_eye'
      ) {
        this.openViewActions(params.data);
      }
    }
    if (col === 'PictureAfter') {
      this.image = params.data.PictureAfter;
      this.imageZoomModal(this.image);
    }
    if (col === 'PreImage') {
      this.spinner.show();
      this.getFiles(params.data.Id)
    }
  }

  getDefectDashboard() {
    this.spinner.show();
    const key = {
      dateStart: this.CLLDashboardForm?.get('datePicker')?.value[0],
      dateEnd: this.CLLDashboardForm?.get('datePicker')?.value[1],
      groupCode: this.groupSession?.groupCode,
      PTCode: this.plantSession?.plantCode,
      DeptId: this.CLLDashboardForm.value.Departments,
      PLID: this.CLLDashboardForm.value.line,
      PUID: this.CLLDashboardForm.value.unit,
      IsMachine: this.IsMachine
    }
    this.rowData = [];
    this.defectService.getDefectDashboard(key).subscribe((data: any) => {
      this.dashboardData = data;
      this.rowData = this.dashboardData?.defectlist;
      this.autoSizeDefect();
      this.spinner.hide();
    }, (error: any) => {
      this.toaster.error(this.t('Error', 'Error'), error.message);
      this.spinner.hide();
    });
  }

  viewAction(element: any): void {
    this.dialog.open(this.popupViewModal, {
      width: '50vw !important',
      height: 'auto',
      minWidth: '50vw',

    })
    this.actionDataSource = element.data.ActionPlan;
  }

  openPictureBeforeModal(): void {
    this.currentImagePath = this.image === ''
      ? 'assets/images/no-image.png'
      : Constants.BLOB_STORAGE_URL + this.image;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  imageZoomModal(imagePath: String): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  public localizeHeader(parameters: any) {
    const colDef = parameters && parameters.colDef ? parameters.colDef : {};
    return this.getTransalatedValue(colDef.field, colDef.headerName);
  }

  /**
   * Resolve a label: langObj -> "<PAGE>.<key>" -> flat "<key>" -> the input.
   * Previously this returned the raw field name when the key was missing, so
   * headers such as 'PL_Desc' and 'DepartmentName' rendered literally.
   */
  getTransalatedValue(value: string, headerLabel?: string): string {
    const candidates: string[] = [];
    if (value) {
      candidates.push(value);
    }
    if (headerLabel) {
      candidates.push(headerLabel, headerLabel.replace(/\s+/g, ''));
    }
    for (const candidate of candidates) {
      if (this.langObj && this.langObj[candidate]) {
        return this.langObj[candidate];
      }
    }
    for (const candidate of candidates) {
      const scoped = this.lookup(`${this.PAGE}.${candidate}`);
      if (scoped) {
        return scoped;
      }
      const flat = this.lookup(candidate);
      if (flat) {
        return flat;
      }
    }
    return headerLabel || value || '';
  }

  private lookup(key: string): string | null {
    const value = this.translate.instant(key);
    if (typeof value === 'string' && value !== key) {
      return value;
    }
    if (value && typeof value === 'object' && typeof value.title === 'string') {
      return value.title;
    }
    return null;
  }

  /** langObj (database) -> "<PAGE>.<key>" -> flat "<key>" -> English fallback. */
  public t(key: string, fallback: string): string {
    if (this.langObj && this.langObj[key]) {
      return this.langObj[key];
    }
    return this.lookup(`${this.PAGE}.${key}`) || this.lookup(key) || fallback;
  }

  /**
   * Rebuild every chart so its title, series names and axis categories follow
   * the language. Highcharts bakes those in at construction, so nothing else
   * updates them. Each builder takes no arguments and reads a field that is
   * already populated, so no request is made; each is guarded individually
   * because before the first load those fields are undefined.
   */
  private redrawCharts(): void {
    const builders = [
      () => this.drawDefectType(),
      () => this.drawDefectClassification(),
      () => this.drawDefectPriority(),
      () => this.drawDefectStatus(),
      () => this.drawCILUnitChart(),
      () => this.drawCilLineChart(),
      () => this.drawCilDeptChart(),
      () => this.drawCILLinePercentage(),
      () => this.drawCILDeptPercentage(),
      () => this.drawCILUnitPercentage(),
    ];
    for (const build of builders) {
      try {
        build();
      } catch (e) { }
    }
  }

  /** Escape a translated value before putting it in an HTML template string. */
  private tHtml(key: string, fallback: string): string {
    return this.t(key, fallback)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /**
   * The empty-state messages belong to the libraries, not to this template:
   * Highcharts renders lang.noData ("No data to display") and ag-Grid renders
   * its own overlay ("No Rows To Show"). Neither can be reached from the i18n
   * files unless it is pushed in like this.
   */
  private applyEmptyStateText(): void {
    // Highcharts only exposes lang globally - there is no per-chart override.
    Highcharts.setOptions({
      lang: { noData: this.t('NoDataToDisplay', 'No data to display') },
    } as any);

    const overlay =
      '<span class="ag-overlay-no-rows-center">' +
      this.tHtml('NoRowsToShow', 'No rows to show') +
      '</span>';
    // ag-Grid re-reads this every time it shows the overlay, so setting it is
    // enough for any future render. Both grids on the page use it.
    this.gridOptions.overlayNoRowsTemplate = overlay;
    this.gridOptionsDefectAction.overlayNoRowsTemplate = overlay;

    // Only force a redraw on an actual language change: on the first pass the
    // grid may still be showing its loading overlay, and hiding that would
    // leave the grid looking empty mid-request.
    if (!this.emptyStateApplied) {
      this.emptyStateApplied = true;
      return;
    }
    if (this.gridApi && this.gridApi.getDisplayedRowCount &&
        this.gridApi.getDisplayedRowCount() === 0) {
      this.gridApi.hideOverlay();
      this.gridApi.showNoRowsOverlay();
    }
  }

  /** Re-read every label that change detection does not re-evaluate. */
  private applyLanguageToView(): void {
    this.applyEmptyStateText();
    this.gridApi?.refreshHeader();
    this.gridApi?.refreshCells({ force: true });
    this.redrawCharts();
  }

  excelExport() {
    const dataSheet = [];
    const workBook = XLSX.utils.book_new();
    if (!this.IsMachine) {
      for (let i of this.rowData) {
        const ExportData = {
          ['DefectEntry ']: i.DefectEntry,
          ['Priority ']: i.Priority,
          ['Status ']: i.Status,
          ['Line']: i.PL_Desc,
          ['Machine']: i.PU_Desc,
          ['Component']: i.ComponentName,
          ['Defect Type ']: i.DefectType,
          ['Created By ']: i.CreatedBy,
          ['Close Date(DD/MM/YYYY HH:mm)']: i.CloseDate ? moment(i.CloseDate).format('DD/MM/YYYY HH:mm:ss') : '',
          ['ClosedBy ']: i.ClosedBy,

        };
        dataSheet.push(ExportData);
      }
      const sheet = XLSX.utils.json_to_sheet(dataSheet);
      XLSX.utils.book_append_sheet(workBook, sheet, 'Defect');
      XLSX.writeFile(workBook, `Defect With  Machine.xlsx`);
    }
    else {
      for (const i of this.rowData) {
        const ExportData = {
          ['DefectEntry ']: i.DefectEntry,
          ['Priority ']: i.Priority,
          ['Status ']: i.Status,
          ['Defect Type ']: i.DefectType,
          ['Created By ']: i.CreatedBy,
          ['Department']: i.DepartmentName,
          ['Created On (DD/MM/YYYY HH:mm)']: i.CreatedOn ? moment(i.CreatedOn).format('DD/MM/YYYY HH:mm:ss') : '',
          ['Close Date(DD/MM/YYYY HH:mm)']: i.CloseDate ? moment(i.CloseDate).format('DD/MM/YYYY HH:mm:ss') : '',
          ['ClosedBy ']: i.ClosedBy,

        };
        dataSheet.push(ExportData);
      }
      const sheet = XLSX.utils.json_to_sheet(dataSheet);
      XLSX.utils.book_append_sheet(workBook, sheet, 'Task');
      XLSX.writeFile(workBook, `Defect With Out Machine.xlsx`);
    }
  }


  csvExport() {
    this.gridApi.exportDataAsCsv();
  }
  //menu and breadcrumb
  // GetBreadcrumList(): any {
  //   const obj = {
  //     MenuId:
  //       localStorage.getItem('O3RightMenuId') === null
  //         ? 1
  //         : localStorage.getItem('O3RightMenuId'),
  //   };
  //   // tslint:disable-next-line: align
  //   this.userService.GetBreadcrumList(obj).subscribe(
  //     (data: any) => {
  //       this.breadcrumList = data.BreadcrumList;
  //       this.moduleId = this.breadcrumList[0].id;
  //       this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
  //       this.getLangWords();
  //     },
  //     (error) => {
  //       this.toaster.error(this.t('Error', 'Error'), error.ErrorMessage);
  //     }
  //   );
  // }

  // GetMenuAccess(): void {
  //   const key = {
  //     Id: localStorage.getItem('O3RightMenuId'),
  //   };
  //   this.enterpriseGroupService.GetMenuAccess(key).subscribe(
  //     (data: any) => {
  //       this.permisson = data;
  //       this.IsAccess = data.IsAccess;
  //       this.IsWrite = data.IsWrite;
  //     },
  //     (error) => {
  //       this.toaster.error(this.t('Error', 'Error'), error.error.message);
  //     }
  //   );
  // }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
    // return false;
  }

  // onChangeGroup(data: any): void {
  //   this.getPlants(data.value);
  // }

  onChangeLine(data: any): void {
    if (parseInt(data.value) === 0) {
      this.filteredUnits.length = 0;
      this.filteredComponents.length = 0;
      this.CLLDashboardForm.controls.unit.patchValue('0');
      this.CLLDashboardForm.controls.components.patchValue('0');
      this.getUnit(parseInt(data.value));
    } else {
      this.getUnit(data.value);
    }
  }

  onChangePlant(data: any) {
    this.getDepartments();
  }

  onChangeDepartments(data: any) {
    this.getLine();
  }

  onChangeUnit(data: any): void {
    this.getComponent(data.value);
  }

  // datasource(): void {
  //   const key = {
  //     UserId: JSON.parse(localStorage.user).UserId,
  //   };
  //   const id = {
  //     value: 0,
  //   };
  //   // tslint:disable-next-line: no-debugger
  //   this.productivityservice.getGroupData(key).subscribe(
  //     (data: any) => {
  //       this.GroupList = data.lstEG;
  //       id.value = data.lstEG[0].EG_Id;
  //       this.CLLDashboardForm.get('UserGroup1')?.setValue(data.lstEG[0].EG_Id);
  //       this.CLLDashboardForm.get('UserPlant1')?.setValue(data.lstEG[0].EG_Id);
  //       this.filteredGroups = this.GroupList.slice();
  //       this.getPlants(id);
  //     },
  //     (error: any) => {
  //       this.toaster.error(this.t('Error', 'Error'), error.message);
  //     }
  //   );
  // }

  // getPlants(event: any): void {
  //   const key = {
  //     EG_ID: event.value,
  //     userId: JSON.parse(localStorage.user).UserId,
  //   };

  //   this.productivityservice.getPlantsData(key).subscribe(
  //     (data: any) => {
  //       this.PlantList1 = data.lstPlant;
  //       const id = data.lstPlant[0].PT_Id;
  //       this.CLLDashboardForm.get('UserPlant1')?.patchValue(id);
  //       this.filteredPlants = this.PlantList1.slice();
  //       this.getDepartments(id);
  //     },
  //     (error: any) => {
  //       this.toaster.error(this.t('Error', 'Error'), error.message);
  //     }
  //   );
  // }

  getDepartments() {
    const key = {
      plantCode: this.plantSession?.plantCode,
    };
    this.spinner.show();
    this.dtService.getDeptData(key).subscribe(
      (res: any) => {
        this.deparmentList = res;
        this.deparmentFiltList = this.deparmentList.slice();
        if (this.deparmentFiltList && this.deparmentFiltList.length) {
          // this.CLLDashboardForm.controls.Departments.patchValue(
          //   this.deparmentList[0].TypeId
          // );
          this.getLine();
        }
        else {
          if (this.flag) {
            this.onSubmit();
          }
        }

        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  getLine() {
    // var selectedDepart : any[] = [];
    // if(this.CLLDashboardForm.value?.line == '0')
    // {
    // for(var i = 0; i< this.deparmentList?.length; i++)
    //  {
    //   selectedDepart.push(this.deparmentList[i].TypeId);
    // }
    // }
    // else {
    //   selectedDepart.push(this.CLLDashboardForm.value.TypeId)
    // }
    const key = {
      PT_Code: this.plantSession?.plantCode,
      Dept_ID: this.CLLDashboardForm.value.Departments,
      // Dept_ID : selectedDepart.toString(),
      UserCode: this.userSession?.userCode,
    };

    this.productivityservice.getLineByDeptData(key).subscribe(
      (data: any) => {
        this.lineList = data.lstLine;
        const lineDefault = this.lineList[0];
        if (this.lineList.length !== 0) {
          // this.CLLDashboardForm.controls.line.patchValue(lineDefault.PL_Id);
          // this.getUnit(lineDefault.PL_Id);
          this.getUnit(0);
        } else {
          if (this.flag) {
            this.onSubmit();
          }

        }
        this.filteredLines = this.lineList.slice();
      },
      (error: any) => {
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  getUnit(id: number) {
    var selectedLine: any[] = [];
    if (this.CLLDashboardForm.value.line == 0) {
      for (var i = 0; i < this.lineList?.length; i++) {
        selectedLine.push(this.lineList[i].PL_Id);
      }
    }
    else {
      selectedLine.push(this.CLLDashboardForm.value.line)
    }
    const key = {
      PL_ID: selectedLine.toString(),
      userCode: this.userSession?.userCode,
      PT_ID: this.CLLDashboardForm.value.UserPlant1,
    };

    this.productivityservice.getUnitData(key).subscribe(
      (data: any) => {
        this.unitList = data.lstUnit;
        const unitDefault = this.unitList[0];
        if (this.unitList.length !== 0) {
          this.getComponent(0);
        } else {
          if (this.flag) {

            this.onSubmit();
          }

        }

        this.filteredUnits = this.unitList.slice();
      },
      (error: any) => {
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  getComponent(id: number) {
    const key = {
      PU_ID: id,
      userCode: this.userSession.userCode,
      PT_ID: this.CLLDashboardForm.value.UserPlant1,
    };
    this.productivityservice.getComponentData(key).subscribe(
      (data: any) => {
        this.componentList = data.lstComponent;
        const comDefault = this.componentList[0];
        this.componentList.length !== 0
          ? this.CLLDashboardForm.controls.components.patchValue(
            comDefault.ComponentId
          )
          : this.CLLDashboardForm.controls.components.patchValue('0');
        this.filteredComponents = this.componentList.slice();
        if (this.flag) {
          this.onSubmit();
        }
      },
      (error: any) => {
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  onSubmit(): void {
    this.getAMCILDashboard();
    this.getDefectDashboard();
    this.flag = false
  }

  getAMCILDashboard() {
    var selectDepartment: any[] = [];
    var selectedLine: any[] = [];
    var selectedUnit: any[] = [];

    const data = {
      dateStart: this.CLLDashboardForm?.get('datePicker')?.value[0],
      dateEnd: this.CLLDashboardForm?.get('datePicker')?.value[1],
      groupCode: this.groupSession?.groupCode,
      PTCode: this.plantSession?.plantCode,
      DeptId: this.CLLDashboardForm.value.Departments,
      PLID: this.CLLDashboardForm.value.line,
      PUID: this.CLLDashboardForm.value.unit,
      IsMachine: this.IsMachine
    };
    this.spinner.show();
    this.dashboardData = [];
    this.linepercentageGraphData = [];
    this.unitpercentageGraphData = [];
    this.DeptpercentageGraphData = [];
    this.dashboardLineData = [];
    this.dashboarUnitData = [];
    this.cilService.getDefectCILDashboard(data).subscribe(
      (data: any) => {
        this.dashboardData = data;
        this.spinner.hide();
        if (this.dashboardData.DefectDashUnitList) {
          this.setDataUnit();
        }
        if (this.dashboardData.DefectDashDeptList) {
          this.setDataDept();
        }
        if (this.dashboardData.DefectDashLineList) {
          this.setDataLine();
        }


      },
      (error: any) => {
        this.toaster.error(this.t('Error', 'Error'), error.message);
        this.spinner.hide();
      }
    );
  }

  setDataDept() {
    if (this.dashboardData !== null) {
      const LineData = [];
      let data = [];
      let machineName = '';
      if (this.dashboardData.DefectDashDeptList) {
        this.dashboardData.DefectDashDeptList.map(
          (plant: any, plantindex: number) => {
            data = [];
            const ID = this.dashboardData.DefectDashDeptList[plantindex].Id;
            const done = this.dashboardData.DefectDashDeptList[plantindex].Done;
            const totalCount =
              this.dashboardData.DefectDashDeptList[plantindex].TotalCount;

            machineName = this.dashboardData.DefectDashDeptList[plantindex].NAME;
            const percentage = (
              (parseInt(done) / parseInt(totalCount)) *
              100
            ).toFixed(2);
            data.push(totalCount);
            data.push(done);
            this.DeptpercentageGraphData.push({
              name: machineName,
              type: 'column',

              data: [parseInt(percentage)],
            });
            LineData.push({
              name: machineName,
              type: 'column',
              data: data,
            });
          }
        );
        this.dashboardDeptData = LineData;
      }
      this.drawCilDeptChart()
    }
  }

  setDataUnit() {
    if (this.dashboardData !== null) {
      if (this.dashboardData.DefectDashUnitList) {
        const unitdata = [];
        let dataUnit = [];
        let machineNameUnit = '';
        this.dashboardData.DefectDashUnitList.map(
          (plant: any, plantindex: number) => {
            dataUnit = [];
            const ID = this.dashboardData.DefectDashUnitList[plantindex].Id;

            machineNameUnit =
              this.dashboardData.DefectDashUnitList[plantindex].Name;
            const done = this.dashboardData.DefectDashUnitList[plantindex].Done;
            const totalCount =
              this.dashboardData.DefectDashUnitList[plantindex].TotalCount;
            const percentage = (
              (parseInt(done) / parseInt(totalCount)) *
              100
            ).toFixed(2);
            dataUnit.push(totalCount);
            dataUnit.push(done);
            this.unitpercentageGraphData.push({
              name: machineNameUnit,
              type: 'column',
              data: [parseInt(percentage)],
            });

            unitdata.push({
              name: machineNameUnit,
              type: 'column',
              data: dataUnit,
            });
          }
        );

        this.dashboarUnitData = unitdata;
      }

      this.drawCILUnitChart();
    }
  }

  setDataLine() {
    if (this.dashboardData !== null) {
      if (this.dashboardData.DefectDashLineList) {
        const unitdata = [];
        let dataUnit = [];
        let machineNameUnit = '';
        this.dashboardData.DefectDashLineList.map(
          (plant: any, plantindex: number) => {
            dataUnit = [];
            const ID = this.dashboardData.DefectDashLineList[plantindex].Id;

            machineNameUnit =
              this.dashboardData.DefectDashLineList[plantindex].Name;
            const done = this.dashboardData.DefectDashLineList[plantindex].Done;
            const totalCount =
              this.dashboardData.DefectDashLineList[plantindex].TotalCount;
            const percentage = (
              (parseInt(done) / parseInt(totalCount)) *
              100
            ).toFixed(2);
            dataUnit.push(totalCount);
            dataUnit.push(done);
            this.linepercentageGraphData.push({
              name: machineNameUnit,
              type: 'column',
              data: [parseInt(percentage)],
            });

            unitdata.push({
              name: machineNameUnit,
              type: 'column',
              data: dataUnit,
            });
          }
        );

        this.dashboardLineData = unitdata;
      }
      this.drawCilLineChart();
    }
  }

  drawCILUnitChart() {
    this.options = {
      chart: {
        type: 'column',
      },

      title: {
        text: this.getTransalatedValue('DefectPlanUnitWise'),
      },

      xAxis: {
        categories: [this.t('DefectFound', 'Defect Found'), this.t('DefectFixed', 'Defect Fixed')],
        labels: {
          style: {

            color: 'black',
            fontSize: '15px',

          },
        },
      },
      credits: {
        enabled: false
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
      },
      plotOptions: {
        column: {
          // pointPadding: 5,
          groupPadding: 0,
          pointWidth: 40,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
          },
        },
      },

      series: this.dashboarUnitData,
    };
    if (
      this.dashboarUnitData.length > 6 &&
      this.dashboarUnitData.length < 10 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 20;
    }

    let chart = new Chart(this.options);
    this.chartUnit = chart;
    this.drawCILUnitPercentage();
  }

  drawCilLineChart() {
    this.options = {
      chart: {
        type: 'column',
      },

      title: {
        text: this.getTransalatedValue('DefectPlanLineWise'),
      },

      xAxis: {
        categories: [this.t('DefectFound', 'Defect Found'), this.t('DefectFixed', 'Defect Fixed'), this.t('AdherencePct', 'Adherence %')],
        labels: {
          style: {
            color: 'black',
            fontSize: '15px',
          },
        },
      },
      credits: {
        enabled: false
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
      },
      plotOptions: {
        column: {
          groupPadding: 0,
          pointWidth: 40,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
          },
        },
      },

      series: this.dashboardLineData,
    };
    if (
      this.dashboardLineData.length > 6 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 20;
    }
    if (
      this.dashboardLineData.length > 10 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 30;
      const width = document.querySelectorAll('div.chart-items-w30-l');
      if (width && width.length) {
        width.forEach((node: any) => (node.style.width = '100%'));
      }

      const widthTwo = document.querySelectorAll('div.chart-items-l');
      if (widthTwo && widthTwo.length) {
        widthTwo.forEach((node: any) => (node.style.width = '100%'));
      }
    } else {
      const width = document.querySelectorAll('div.chart-items-w30-l');
      if (width && width.length) {
        width.forEach((node: any) => (node.style.width = '47%'));
      }

      const widthTwo = document.querySelectorAll('div.chart-items-l');
      if (widthTwo && widthTwo.length) {
        widthTwo.forEach((node: any) => (node.style.width = '48%'));
      }
    }

    let chart = new Chart(this.options);
    this.chartLine = chart;

    this.drawCILLinePercentage();
  }

  drawCilDeptChart() {
    this.options = {
      chart: {
        type: 'column',
      },

      title: {
        text: this.getTransalatedValue('DefectPlanDepartmentWise'),
      },

      xAxis: {
        categories: [this.t('DefectFound', 'Defect Found'), this.t('DefectFixed', 'Defect Fixed'), this.t('AdherencePct', 'Adherence %')],
        labels: {
          style: {
            color: 'black',
            fontSize: '15px',
          },
        },
      },
      credits: {
        enabled: false
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
      },
      plotOptions: {
        column: {
          groupPadding: 0,
          pointWidth: 40,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
          },
        },
      },

      series: this.dashboardDeptData,
    };
    if (
      this.dashboardDeptData.length > 6 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 20;
    }
    if (
      this.dashboardDeptData.length > 10 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 30;
      const width = document.querySelectorAll('div.chart-items-w30-l');
      if (width && width.length) {
        width.forEach((node: any) => (node.style.width = '100%'));
      }

      const widthTwo = document.querySelectorAll('div.chart-items-l');
      if (widthTwo && widthTwo.length) {
        widthTwo.forEach((node: any) => (node.style.width = '100%'));
      }
    } else {
      const width = document.querySelectorAll('div.chart-items-w30-l');
      if (width && width.length) {
        width.forEach((node: any) => (node.style.width = '47%'));
      }

      const widthTwo = document.querySelectorAll('div.chart-items-l');
      if (widthTwo && widthTwo.length) {
        widthTwo.forEach((node: any) => (node.style.width = '48%'));
      }
    }

    let chart = new Chart(this.options);
    this.chartDept = chart;

    this.drawCILDeptPercentage();
  }

  drawCILLinePercentage() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.getTransalatedValue('AdherenceLineWise'),
      },

      xAxis: {
        categories: [this.t('AdherenceInPct', 'Adherence in %')],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: '',
        },
        labels: {
          overflow: 'justify',
        },
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        column: {
          pointPadding: 4,
          // groupPadding: 0.5,
          pointWidth: 50,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{y} %',
          },
        },
      },
      series: this.linepercentageGraphData,
    };
    if (
      this.linepercentageGraphData.length > 8 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 20;
    }

    let chart = new Chart(this.options);
    this.chartLinePercentage = chart;
  }

  drawCILDeptPercentage() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.getTransalatedValue('AdherenceDepartmentWise'),
      },

      xAxis: {
        categories: [this.t('AdherenceInPct', 'Adherence in %')],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: '',
        },
        labels: {
          overflow: 'justify',
        },
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        column: {
          pointPadding: 4,
          // groupPadding: 0.5,
          pointWidth: 50,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{y} %',
          },
        },
      },
      series: this.DeptpercentageGraphData,
    };
    if (
      this.DeptpercentageGraphData.length > 8 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 20;
    }

    let chart = new Chart(this.options);
    this.chartDeptPercentage = chart;
  }

  drawCILUnitPercentage() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.getTransalatedValue('AdherenceUnitWise'),
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: [this.t('AdherenceInPct', 'Adherence in %')],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: '',
        },
        labels: {
          overflow: 'justify',
        },
      },

      plotOptions: {
        column: {
          pointPadding: 4,
          // groupPadding: 0.5,
          pointWidth: 50,
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            format: '{y} %',
          },
        },
      },

      series: this.unitpercentageGraphData,
    };
    if (
      this.unitpercentageGraphData.length > 6 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 20;
    }

    if (
      this.unitpercentageGraphData.length > 10 &&
      this.options &&
      this.options.plotOptions.column.pointWidth
    ) {
      this.options.plotOptions.column.pointWidth = 30;
      const width = document.querySelectorAll('div.chart-items-w30-u');
      if (width && width.length) {
        width.forEach((node: any) => (node.style.width = '100%'));
      }

      const widthTwo = document.querySelectorAll('div.chart-items-u');
      if (widthTwo && widthTwo.length) {
        widthTwo.forEach((node: any) => (node.style.width = '100%'));
      }
    } else {
      const width = document.querySelectorAll('div.chart-items-w30-u');
      if (width && width.length) {
        width.forEach((node: any) => (node.style.width = '47%'));
      }

      const widthTwo = document.querySelectorAll('div.chart-items-u');
      if (widthTwo && widthTwo.length) {
        widthTwo.forEach((node: any) => (node.style.width = '48%'));
      }
    }
    let chart = new Chart(this.options);
    this.chartUnitPercentage = chart;
  }

  onCheckboxChange(checkBoxStatus: any): void {
    this.IsMachine = checkBoxStatus.checked;
    this.columnDefs = [
      {
        field: 'Action', headerName: 'Action', cellRenderer: 'BtnCellRendererDefectDashBoard',
        cellRendererParams: {
          clicked: function (field: any) { },
          // lets the renderer resolve its tooltips for this page, and pick up
          // database translations the same way the rest of the page does
          page: 'NewDefectDashboard',
          getLangObj: () => this.langObj,
        },
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        maxWidth: 100
      },
      { headerName: 'Defect Entry', field: 'DefectEntry', filter: true },
      { headerName: 'Priority', field: 'Priority', filter: true },
      { headerName: 'Status', field: 'Status', filter: true },
      { headerName: 'Line', field: 'PL_Desc', filter: true, hide: this.IsMachine },
      { headerName: 'Machine', field: 'PU_Desc', filter: true, hide: this.IsMachine },
      { headerName: 'Component', field: 'ComponentName', filter: true, hide: this.IsMachine },
      { headerName: 'Department', field: 'DepartmentName', filter: true, hide: !this.IsMachine },
      { headerName: 'Defect Type', field: 'DefectType', filter: true },
      { headerName: 'Pre Image', field: 'PreImage', cellRenderer: function (params: any) { return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value}" src="${params.value !== '' ? params.value : 'assets/images/no-image.png'}">` } },
      { headerName: 'Created By', field: 'CreatedBy', filter: true },
      { headerName: 'Created On', field: 'CreatedOn', filter: true, valueFormatter: function (params: any) { return moment(params.value).format('DD/MM/YYYY HH:mm:ss') } },
      { headerName: 'Close Date', field: 'CloseDate', filter: true, valueFormatter: function (params: any) { return params.value !== null ? moment(params.value).format('DD/MM/YYYY HH:mm:ss') : '' } },
      { headerName: 'Closed By', field: 'ClosedBy', filter: true },
    ]
    // This rebuild replaces the column definitions wholesale and none of them
    // carry a headerValueGetter, so toggling the checkbox reverted every header
    // to English. Re-attach the resolver to any column that lacks one.
    this.columnDefs = this.columnDefs.map((col: any) =>
      col && col.headerName && !col.headerValueGetter
        ? { ...col, headerValueGetter: this.localizeHeader.bind(this) }
        : col
    );
    this.dashboarUnitData = [];
    this.dashboardLineData = [];
    this.dashboardDeptData = [];
    this.linepercentageGraphData = [];
    this.DeptpercentageGraphData = [];
    this.unitpercentageGraphData = [];

    this.chartUnit = null
    this.chartUnitPercentage = null;
    this.chartLine = null;
    this.chartLinePercentage = null;
    this.chartDept = null;
    this.chartDeptPercentage = null;
    this.rowData = [];
    this.onSubmit();

  }

  imageModal(): void {
    this.currentImagePath = this.CloseImage;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  openViewActions(defect: any): void {
    this.getDefectActions(defect.Id);
  }

  getDefectActions(id: number): void {
    const key = {
      DefectId: id
    };
    // this.rowDataViewActions = [];
    this.defectActionService.getDefectActions2(key).subscribe((res) => {
      this.rowDataViewActions = res;
      if (this.rowDataViewActions?.length > 0) {
        this.dialog.open(this.ViewActionDetailModel, { height: 'auto', width: '90%' });
      }
      else {
        this.toaster.warning("Actions Not Available")
      }
      this.autoSizeGrid();
    });
  }

  getFiles(id: number): void {
    const key = {
      defectId: id
    };
    this.slidesImages = []
    this.defectService2.getDefectfiles(key).subscribe((res: any) => {
      if (res?.length) {
        this.spinner.hide();
        this.dialog.open(this.imageViewModal, {
          height: 'auto',
          width: '90%',
        });
        for (let obj of res) {
          this.slidesImages.push(obj.FilePath)
        }
      }
      else {
        this.spinner.hide();
        this.toaster.warning(this.t('Warning', 'Warning'), this.t('NoImageAvailable', 'There is no image available'))
      }
    });
  }
}
